export const environment = {
  production: false,
  version: "2021.0",//No cambiar a menos que se cree un nuevo proyecto
  secret_key: "dff5091000396f57ed039129a4e5472b",
  iv: "JSyC2d1SfTArQL9fbTA25A==",
  jamaradmin_key: "G0DFOPNx5yIVCXHFbcTA14c6uWmusi",
  api_key: 'd47c29cfdf8e2456ac678c51f9e4ddfa8ec577f64e98aa9e863399f6a10210d4',
  c2VjcmV0S2V5:"LefjQ2pEXmiy/nNZvEJ43i8hJuaAnzbA1Cbn1hOuAgA=", //dev
  token:'',

  environment: "development",
  reporteApiUrl: "https://da11yhlkl5.execute-api.us-east-1.amazonaws.com/dev/api/v1",
  adminRoute: "admin",
  authRoute: "auth",
  domain: "https://appsdev.mueblesjamar.com.co",
  domainBasics: "https://n1zekhwf8e.execute-api.us-east-1.amazonaws.com/dev/v1/{{c_emp}}/jamaradmin/basics/",
  domainChangePassword: "https://n1zekhwf8e.execute-api.us-east-1.amazonaws.com/dev/v1/jamaradmin/basics/",
  apiUrl: "http://localhost:8001", // URL del nuevo backend
  soeApiUrldev: "http://localhost:8001",
  // soeApiUrldev: "https://oxibshigni.execute-api.us-east-1.amazonaws.com/dev",
  tciApiUrldev: "https://ykgcq7un08.execute-api.us-east-1.amazonaws.com/dev",
  encryptLocalStorage: false,
  //urls basicas necesarias para el buen funcionamiento del framework
  urls: {
    auth: {
      login: { value: "auth/login/post", method: "POST", contentType: "application/json" },
      register: { value: "auth/register/post", method: "POST", contentType: "application/json" },
      modify: { value: "auth/modify/post", method: "POST", contentType: "application/json" },
      modules: { value: "auth/modulos/get", method: "GET", contentType: "application/json" },
      moduleOptions: { value: "auth/modulos/opciones/get", method: "GET", contentType: "application/json" },
      changePassword: { value: "auth/pasword/user/change/post", method: "POST", contentType: "application/json" },
      reset: { value: "auth/pasword/reset/post", method: "POST", contentType: "application/json" },
    },
    generals: { value: "/UtilitiesService/api/utilities/getProperties", method: "GET", contentType: "application/x-www-form-urlencoded" },
    query: {
      Select: { value: "query/select/post", method: "POST", contentType: "application/json" },
      SelectQuery: { value: "query/select/sql/post", method: "POST", contentType: "application/json" },
      Insert: { value: "query/insert/post", method: "POST", contentType: "application/json" },
      Update: { value: "query/update/post", method: "POST", contentType: "application/json" },
      Delete: { value: "query/delete/post", method: "POST", contentType: "application/json" },
    },
    reporte: {
      listarCampanias: { value: "JA/listar_campanias", method: "GET", contentType: "application/json" },
      reporteCampania: { value: "reporte_campania", method: "POST", contentType: "application/json" },
    }
  },

  /**
   * Dominios (dominio.com) a los que se enviará el token en el header de la petición.
   * Utilizar solo en caso que el dominio sea distinto del actual, ya que es allowed por defecto.
   */
  allowedDomains: [
    "https://n1zekhwf8e.execute-api.us-east-1.amazonaws.com/dev/v1/JA",
    "https://2ghgpw90t6.execute-api.us-east-1.amazonaws.com/prd/v1/JA",
    "https://n1zekhwf8e.execute-api.us-east-1.amazonaws.com/dev/v1/JP",
    "https://2ghgpw90t6.execute-api.us-east-1.amazonaws.com/prd/v1/JP",
    "http://localhost:8001"
  ],
  /**
   * Rutas en las que no se tendrá en cuenta el envío del token.
   * Pueden ser del mismo dominio.
   */
  disallowedRoutes: [],
  //Constants
  COOKIE_USER: "user_info", //nombre de la cookie donde se almacena la informacion del usuario
  COOKIE_USERK: "jsfb_assff", //nombre de la cookie donde se almacena la informacion del usuario
  COOKIE_USER_SESSIONS: "jsfb_NMassff", //nombre de la cookie donde se almacena la informacion del usuario
  MAX_USER_SESSIONS: "max_jsfb_NMassff", //nombre de la cookie donde se almacena la informacion del usuario
  COOKIE_TOKEN: "token", //nombre de la cookie donde se almacena el token de la sesión
  LOCAL_CONNECTION: "con",
  LOCAL_ENDPOINTS: "endpoints", //nombre de la cookie donde se almacenan los endpoints
  LOCAL_MODULES: "modulos",
  LOCAL_MODULE_OPTIONS: "module_options",
  LOCAL_CURRENT_MODULE: "current_options",
  LOCAL_ROLES: "roles",
  LOCAL_RECENT_MODULES: "recent_modules",
  LOCAL_LAST_URL: "last_url",
  LOCAL_GENERALS: "generals",
  LOCAL_PROPERTIES: "properties",
  MESSAGES_DURATION: 5000, //Duracion de los mensajes de snackbar
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
